import { useSite } from "@/context/SiteContext";
import { InstagramIcon, TikTokIcon } from "@/components/site/SocialIcons";

export const SocialSection = () => {
  const { site } = useSite();
  const s = site.settings;
  if (!s.instagram_url && !s.tiktok_url) return null;
  return (
    <section className="pb-12 sm:pb-16" data-testid="social-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-nanina-green text-white p-6 sm:p-9 flex flex-col md:flex-row md:items-center justify-between gap-5">
          <div className="pointer-events-none absolute right-[22%] -top-20 h-64 w-64 rounded-full border border-white/10 shadow-[0_0_0_48px_rgba(255,255,255,0.035)]" />
          <div className="relative">
            <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight">{s.social_title}</h2>
            <p className="mt-2 text-sm text-[#DCF0E9] max-w-lg">{s.social_description}</p>
          </div>
          <div className="relative flex flex-col sm:flex-row gap-2.5">
            {s.instagram_url && (
              <a href={s.instagram_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-nanina-green text-sm font-semibold px-5 py-3 hover:-translate-y-0.5 transition-transform" data-testid="social-instagram-link">
                <InstagramIcon /> Instagram {s.instagram_handle}
              </a>
            )}
            {s.tiktok_url && (
              <a href={s.tiktok_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D5ECF8] text-nanina-green text-sm font-semibold px-5 py-3 hover:-translate-y-0.5 transition-transform" data-testid="social-tiktok-link">
                <TikTokIcon /> TikTok {s.tiktok_handle}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
